import {LinearProgress} from '@mui/material';
import AnalyticsGateway from 'lib/AnalyticsGateway';

/* eslint-disable react/prop-types */
const renderUpload = (
  {
    className,
    isDragActive = false,
    uploadText = 'Uploading image...',
    uploadProgress
  }
) => {
  return (
    <div className={`{${className ?? ''} ${isDragActive ? 'active' : ''} file-upload-uploading`}>
      <div className="upload-text">{uploadText}</div>
      <LinearProgress variant="determinate" value={uploadProgress}/>
    </div>
  );
};

const shouldRenderUploadProgress = (uploadProgress) => {
  return uploadProgress > 0 && uploadProgress < 100;
};

function notifyUploadEvent({propertyId, objectContext, pageContext, eventType}) {
  AnalyticsGateway.sendEvent({
    eventName: 'Upload Property Image',
    properties: [
      {label: 'Page', value: pageContext},
      {label: 'Object Context', value: `${objectContext} Photo ${eventType}`},
      {label: 'Property ID', value: propertyId}
    ]
  });
}

export {
  notifyUploadEvent,
  renderUpload,
  shouldRenderUploadProgress,
};
